import { DELIVERY_OPTIONS, FREE_SHIPPING_MIN_TOTAL, SUB_FREE_SHIPPING_MIN_QTY, SUB_FREQUENCIES, SUB_SHIPPING_COST, WEIGHTS, } from '../constants/index.js';
export function unitPrice(basePrice, weight) {
    const entry = WEIGHTS.find((w) => w.key === weight);
    if (!entry)
        throw new Error(`Unknown weight: ${weight}`);
    return Math.round(basePrice * entry.multiplier);
}
export function lineTotal(basePrice, weight, qty) {
    return unitPrice(basePrice, weight) * qty;
}
export function tasteProfile(p) {
    if (p.acid >= 8)
        return 'acidic';
    if (p.bitter >= 6)
        return 'chocolate';
    return 'balanced';
}
const moneyFormatter = new Intl.NumberFormat('uk-UA');
export function formatMoney(value) {
    return `${moneyFormatter.format(Math.round(value)).replace(/ /g, ' ')} ₴`;
}
export function orderTotal(items, deliveryKey) {
    const itemsTotal = items.reduce((sum, item) => sum + item.unitPrice * item.qty, 0);
    const delivery = DELIVERY_OPTIONS.find((option) => option.key === deliveryKey);
    if (!delivery)
        throw new Error(`Unknown delivery key: ${deliveryKey}`);
    const shipping = itemsTotal >= FREE_SHIPPING_MIN_TOTAL ? 0 : delivery.cost;
    return itemsTotal + shipping;
}
// Скільки ще треба додати товарів (без урахування доставки), щоб доставка
// стала безкоштовною. 0, якщо поріг вже досягнутий або перевищений.
export function amountUntilFreeShipping(itemsTotal) {
    return Math.max(0, FREE_SHIPPING_MIN_TOTAL - itemsTotal);
}
export function subscriptionTotal(unit, qty, freq) {
    const frequency = SUB_FREQUENCIES.find((entry) => entry.key === freq);
    if (!frequency)
        throw new Error(`Unknown frequency: ${freq}`);
    const discounted = Math.round(unit * qty * (1 - frequency.discount));
    const shipping = qty >= SUB_FREE_SHIPPING_MIN_QTY ? 0 : SUB_SHIPPING_COST;
    return discounted + shipping;
}
